<template>
  <div id="app">
    <header v-click-outside="closeUserControl">
      <div class="fc-login">
        <div class="ui container">
          <div>Get 5% cash rebate for your next order!</div>
          <div class="fc-mobile-hide">
            <div>
              <router-link :to="`${this.RouterConfig.OurLocation}`">Our Location</router-link>
            </div>
            <div class="fc-user-info">
              <a v-if="loginInfo == null" @click="showlogin = !showlogin">Login / Register</a>
              <a v-if="loginInfo != null" @click="showUserControl = !showUserControl">{{loginInfo.FullName}}</a>
              <ul v-if="showUserControl" class="fc-user-control">
                <li class="fc-order"><a @click="myOrders">My Orders</a></li>
                <li class="fc-credit"><a @click="myCredit">My Credit</a></li>
                <li class="fc-address"><a @click="myInformation">My Information</a></li>
                <li class="fc-logout"><a @click="logout">Logout</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="ui container fc-navigator">
        <div>
          <a v-bind:class="{ 'fc-mobile-show': true, 'fc-mobile-menu': true, 'fc-active': isMobileMenuActive }" @click="isMobileMenuActive = !isMobileMenuActive"></a>
          <a href="/" class="fc-mobile-hide icon-logo"></a>
          <div v-bind:class="{ 'fc-mobile-nav': true, 'fc-active': isMobileMenuActive }" @touchmove.prevent @click.self="isMobileMenuActive = false">
            <ul v-if="categoryList != null && categoryList != undefined">
              <li v-for="item in categoryList">
                <a :href="item.UrlAliase">{{ item.Name }}</a>
              </li>
            </ul>
            <ul class="fc-mobile-show">
              <li><a @click="ourLocation">Our Location</a></li>
              <li>
                <a v-if="loginInfo == null" @click="showlogin = !showlogin">Login / Register</a>
                <a v-if="loginInfo != null" class="fc-user-info" @click="showUserControl = !showUserControl">{{loginInfo.FullName}}</a>
                <ul v-if="showUserControl" class="fc-user-control">
                  <li class="fc-order"><a @click="myOrders">My Orders</a></li>
                  <li class="fc-credit"><a @click="myCredit">My Credit</a></li>
                  <li class="fc-address"><a @click="myInformation">My Information</a></li>
                  <li class="fc-logout"><a @click="logout">Logout</a></li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <div class="fc-mobile-show"><a href="/" class="icon-logo2"></a></div>
        <fc-cart></fc-cart>
      </div>
    </header>
    <main>
      <router-view></router-view>
    </main>
    <footer>
      <div class="ui container">
        <div class="fc-help">
          <div>
            <span>MENU</span>
            <ul v-if="categoryList != null && categoryList != undefined">
              <li v-for="item in categoryList">
                <a :href="item.UrlAliase">{{ item.Name }}</a>
              </li>
            </ul>
          </div>
          <div>
            <span>SUPPORT</span>
            <ul>
              <li>
                <router-link :to="`${this.RouterConfig.OurLocation}`">Our Locations</router-link>
              </li>
              <li>
                <router-link :to="`${this.RouterConfig.ContactUs}`">Contact Us</router-link>
              </li>
              <li style="display: none;"><a href="/">Career</a></li>
              <li>
                <router-link :to="`${this.RouterConfig.FAQ}`">FAQ</router-link>
              </li>
              <li>
                <router-link :to="`${this.RouterConfig.UserTerm}`">Terms & Conditions</router-link>
              </li>
              <li>
                <router-link :to="`${this.RouterConfig.PrivacyPolicy}`">Privacy Policy</router-link>
              </li>
            </ul>
          </div>
        </div>
        <div class="fc-copyright">
          <div>
            <i class="icon-halal-logo"></i>
            <i class="icon-logo-visa"></i>
            <i class="icon-logo-mastercard"></i>
            <i class="icon-logo-amex"></i>
            <i class="icon-logo-stripe"></i>
          </div>
          <div>
            <b>SUBWAY® is a Registered Trademark of Subway IP Inc. ©2017 Subway IP Inc</b>
            <p>Copyright © 2019 Daily Bake 2 Pte Ltd . All Rights Reserved.</p>
          </div>
        </div>
      </div>
    </footer>
    <scroll-top></scroll-top>
    <fc-login v-if="showlogin" v-on:closelogin="showlogin = false"></fc-login>
    <pickup-or-delivery></pickup-or-delivery>
    <loading style="display: none;" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ScrollTop from './components/PageScroll/ScrollToTop'
import LoginComponent from './components/Login'
import CartComponent from './components/checkout/Cart'
import ClickOutside from 'vue-click-outside'
import PickupOrDelivery from './components/checkout/PickupOrDelivery'
import Loading from './components/common/Loading'
import $ from 'jquery'
export default {
  // asyncData ({ store }) {
  //   return store.dispatch('category/getCategory')
  // },
  name: 'app',
  components: {
    'scroll-top': ScrollTop,
    'fc-login': LoginComponent,
    'fc-cart': CartComponent,
    'loading': Loading,
    'pickup-or-delivery': PickupOrDelivery
  },
  created () {
    this.$store.dispatch('category/getCategory')
    this.$store.dispatch('cart/generateTokenId')
    this.$store.dispatch('profileLogin/checkLogin')

    if (process.browser) {
      const _this = this
      var sessionStorageTransfer = function (event) {
        if (!event) { event = window.event }
        if (!event.newValue) return
        if (event.key === 'getSessionStorage') {
          localStorage.setItem('sessionStorage', JSON.stringify(sessionStorage))
          localStorage.removeItem('sessionStorage')
        } else if (event.key === 'sessionStorage' && !sessionStorage.length) {
          var data = JSON.parse(event.newValue)
          for (var key in data) {
            sessionStorage.setItem(key, data[key])
          }
          _this.$store.dispatch('profileLogin/checkLogin')
        }
      }

      if (window.addEventListener) {
        window.addEventListener('storage', sessionStorageTransfer, false)
      } else {
        window.attachEvent('onstorage', sessionStorageTransfer)
      }
      if (!sessionStorage.length) {
        localStorage.setItem('getSessionStorage', 'foobar')
        localStorage.removeItem('getSessionStorage', 'foobar')
      }
    }
  },
  data () {
    return {
      isMobileMenuActive: false,
      showlogin: false,
      showUserControl: false
    }
  },
  methods: {
    closeUserControl: function () {
      this.showUserControl = false
      this.isMobileMenuActive = false
    },
    myOrders: function () {
      this.showUserControl = false
      this.isMobileMenuActive = false
      this.$router.push(this.RouterConfig.MyOrders)
    },
    myInformation: function () {
      this.showUserControl = false
      this.isMobileMenuActive = false
      this.$router.push(this.RouterConfig.MyInformation)
    },
    myCredit: function () {
      this.showUserControl = false
      this.isMobileMenuActive = false
      this.$router.push(this.RouterConfig.MyCredit)
    },
    ourLocation: function () {
      this.isMobileMenuActive = false
      this.$router.push(this.RouterConfig.OurLocation)
    },
    logout: function () {
      const _this = this
      if (process.browser) {
        $.confirm({
          title: 'Warning',
          content: 'Logout?',
          type: 'orange',
          useBootstrap: false,
          buttons: {
            tryAgain: {
              text: 'OK',
              action: function () {
                _this.$store.dispatch('profileLogin/logout')
                  .then(() => {
                    _this.$router.push(_this.RouterConfig.Home)
                  })
              }
            },
            close: function () {
            }
          }
        })
      }
    }
  },
  computed: {
    ...mapGetters('profileLogin', ['loginInfo']),
    ...mapGetters('category', ['categoryList']),
    ...mapGetters('cart', ['isFirstItem'])
  },
  directives: {
    ClickOutside
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue